@let reviewForm = form();

<div [formGroup]="reviewForm">
  <input panCheckbox checked formControlName="isTheft" id="isTheft" type="checkbox" value="" data-testid="isTheft" />
  <label class="ms-2 text-sm font-medium text-gray-900" for="isTheft"> Suspected theft found </label>
</div>
